export const loadVODPlayer = () =>
  import(
    /* webpackChunkName: "widget/vod-player" */
    '@wix/wix-vod-shared/dist/esm/widget/vod-player/vod-player'
  );
